import FileAlt from 'components/Svg/FileAlt';

const getFileTitle = (filename) => {
    let name = filename.split('.').slice(0, -1).join('.');
    name = name.split('_').join(' ');
    name = name.split('-').join(' ');

    return name;
};

const getFileName = (filename) => {
    return filename.split('.').slice(0, -1).join('.').toLowerCase();
};

const getFileType = (type) => {
    const boom = type.split('/');
    return boom.pop().toLowerCase();
};

const getFileExtension = (filename) => {
    return filename.substr(filename.lastIndexOf('.') + 1).toLowerCase();
};

const readFile = (selectedFile) => {
    return new Promise((resolve) => {
        const reader = new FileReader();

        reader.addEventListener(
            'load',
            () => {
                resolve(reader.result);
            },
            false
        );

        reader.readAsDataURL(selectedFile);
    });
};

const getImageTypes = () => {
    return ['jpg', 'jpeg', 'png', 'svg', 'bmp', 'webp'];
};

const getDocsTypes = () => {
    return [
        'ai',
        'svg',
        'eps',
        'bmp',
        'doc',
        'docx',
        'xls',
        'xlsx',
        'ppt',
        'pptx',
        'txt',
        'odt',
        'pdf',
        'avi',
        'mov',
        'quicktime',
        'mpg',
        'mpeg',
        'mp4',
        'wmv',
        'csv',
        'key',
        'pages',
        'numbers',
        'rtf',
        'tiff',
        'tif',
    ];
};

const getFilesTypes = () => {
    return [...getImageTypes(), ...getDocsTypes()];
};

const getAllowedTypes = (type) => {
    let allowedTypes = [];

    switch (type) {
        case 'images':
            allowedTypes = getImageTypes();
            break;
        case 'docs':
            allowedTypes = getDocsTypes();
            break;
        case 'files':
            allowedTypes = getFilesTypes();
            break;
        case Array.isArray(type):
            allowedTypes = type;
            break;
        default:
            break;
    }

    return allowedTypes;
};

const getShortFileName = (val, limit = 18, trailing = 4) => {
    if (val.length <= limit) return val;

    let ext = getFileExtension(val);

    const SUFFIX_LENGTH = ext.length + trailing + 3; // 3 === ...

    const shortFileNamePrefix = val.slice(0, limit - SUFFIX_LENGTH); // chars before `...`
    const shortFileNameSuffix = val.slice((limit - SUFFIX_LENGTH) * -1); // chars after `...`

    return `${shortFileNamePrefix}...${shortFileNameSuffix}`;
};

const getFileExtPreview = (ext) => {
    return (
        <>
            <FileAlt />
            <span className="fileExtLabel">{ext}</span>
        </>
    );
};

export {
    getFileTitle,
    getFileName,
    getFileType,
    getFileExtension,
    readFile,
    getAllowedTypes,
    getShortFileName,
    getImageTypes,
    getFileExtPreview,
};
